export default __webpack_public_path__ + "static/Doug.Armstrong_social-9a11745f4e1f90607a8025cc5844f80c.jpg";